module.exports = __webpack_public_path__ + "media/icons/favourite-no-dc024aeb.png";